// extracted by mini-css-extract-plugin
export default {"Text":"iteration-diff-value-module__Text__T7pceBx","Text_1":"iteration-diff-value-module__Text_1__ptFVOWA","Text_2":"iteration-diff-value-module__Text_2__pZYo7tJ"};